import { OrderQuantity } from "../../modules/reports/models/order-quantity";
import { ApiEndpoints } from "../../utils/app-constants";
import { toCondensedDate, toShortDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS } from "../utilities/type-models";

export class StickersReportDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'POST';
    public data: any = {};

    public url: string = '';

    constructor(orders: Array<OrderQuantity>) {
        this.data.orders = orders;
        this.url = ApiEndpoints.STICKERS_REPORT;
        this.filename = `Stickers_${toCondensedDate(new Date())}`;
    }
}
